import React, { useState, useEffect } from "react";
import "../Styles/Home.css";
import Navbar from "../Components/Navbar";
import HeroSection from "../Components/HomeComponents/HeroSection";
import BrowserScreen from "../Components/HomeComponents/BrowserScreen";
import StocksPortion from "../Components/HomeComponents/StocksPortion";
import EarningsPortion from "../Components/HomeComponents/EarningsPortion";
import AnalyticsPortion from "../Components/HomeComponents/AnalyticsPortion";
import PressPortion from "../Components/HomeComponents/PressPortion";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import TopGainersLosers from "../Components/HomeComponents/TopGainersLosers";
import PremiumPitch from "../Components/HomeComponents/PremiumPitch";
import FooterPart from "../Components/HomeComponents/FooterPart";

const Home = () => {
  const [theme, setTheme] = useState("blue");
  useEffect(() => {
    setTimeout(() => {
      if (theme == "green") {
        setTheme("blue");
      }
      if (theme == "blue") {
        setTheme("yellow");
      }
      if (theme == "yellow") {
        setTheme("green");
      }
    }, 8000);
  }, [theme]);
  return (
    <>
      {" "}
      <Navbar />
      <div className="home__page">
        <HeroSection theme={theme} />
        <div className={`animated__cylinder ${theme}`}></div>
        <BrowserScreen theme={theme} />
        <StocksPortion theme={theme} />
        {/* <TopGainersLosers /> */}
        {/* <EarningsPortion /> */}
        <PremiumPitch />
        <AnalyticsPortion theme={theme} />
        {/* <PressPortion /> */}
        {/* <div className="get__started__container"></div>
        <h1 className="get__started__main__heading">Get Started Today</h1>
        <p className="get__started__sub__heading">Ready To See All Stocks?</p>
        <div className="get__started__btn">
          {" "}
          <span className="text">Start 14 Days Free Trial</span>
          <ArrowForwardIcon />
        </div>
        <h1 className="footer__logo">
          <span className="text">InvestCharts</span>
        </h1> */}
        <FooterPart />
      </div>
    </>
  );
};

export default Home;
